import { render, staticRenderFns } from "./accountManagersHistory.vue?vue&type=template&id=f4b2de00&scoped=true&"
import script from "./accountManagersHistory.vue?vue&type=script&lang=js&"
export * from "./accountManagersHistory.vue?vue&type=script&lang=js&"
import style0 from "./accountManagersHistory.vue?vue&type=style&index=0&id=f4b2de00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b2de00",
  null
  
)

export default component.exports